export default "__VITE_ASSET__DKG2KfbL__"